(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tl-event-brief"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.tl-brief'); if(!root) return;
  var I = {}; try { I = JSON.parse((document.getElementById('tl-brief-i18n')||{}).textContent || '{}'); } catch(e) { I = {}; }
  function L(k, d){ return (I && I[k]) ? I[k] : d; }
  var tipsSec = document.getElementById('tl-tips');
  var slug = tipsSec ? tipsSec.getAttribute('data-event-slug') : '';
  var titleEl = root.querySelector('.tl-hero h1');
  var name = titleEl ? titleEl.textContent.trim() : L('thisRace', 'this race');
  var TL_EVENT = {
    title: name + L('titleSuffix', " — beginner's Event Brief"),
    text: L('textA', 'Found our race: ') + name + L('textB', '. This beginner brief has the course, costs, where to stay & a race-morning plan:'),
    url: location.href,
    image: "https://triathlon.mx/cdn/shop/files/trilaunchpadlogo_56508aac-93fa-4814-a0f4-89b50eb64a3c.png"
  };
  window.tlShareNative = function(){
    if(navigator.share){ navigator.share(TL_EVENT).catch(function(){}); }
    else { var b=document.getElementById('tl-share-bar'); b&&b.scrollIntoView({behavior:'smooth'}); }
  };
  (function buildShareBar(){
    var bar=document.getElementById('tl-share-bar'); if(!bar) return;
    var u=encodeURIComponent(TL_EVENT.url), t=encodeURIComponent(TL_EVENT.text), ti=encodeURIComponent(TL_EVENT.title), img=encodeURIComponent(TL_EVENT.image);
    var links=[["💬 WhatsApp","https://wa.me/?text="+t+"%20"+u],["📌 Pinterest","https://pinterest.com/pin/create/button/?url="+u+"&media="+img+"&description="+t],
      ["📘 Facebook","https://www.facebook.com/sharer/sharer.php?u="+u],[L('post','𝕏 Post'),"https://twitter.com/intent/tweet?url="+u+"&text="+t],
      ["💼 LinkedIn","https://www.linkedin.com/sharing/share-offsite/?url="+u],[L('email','✉️ Email'),"mailto:?subject="+ti+"&body="+t+"%20"+u]];
    links.forEach(function(l){ var a=document.createElement('a'); a.href=l[1]; a.target='_blank'; a.rel='noopener'; a.textContent=l[0]; bar.appendChild(a); });
    var copyLabel = L('copy','🔗 Copy link');
    var copy=document.createElement('button'); copy.textContent=copyLabel;
    copy.onclick=function(){ navigator.clipboard&&navigator.clipboard.writeText(TL_EVENT.url); copy.textContent=L('copied','✓ Copied'); setTimeout(function(){copy.textContent=copyLabel;},1500); };
    bar.appendChild(copy);
  })();
  window.tlSubmitTip = function(e){
    e.preventDefault();
    var f=e.target, status=document.getElementById('tl-tip-status');
    var payload={ eventId:slug, name:f.name.value.trim(), category:f.category.value, tip:f.tip.value.trim(), email:f.email.value.trim(), source:'event-brief', lang:L('lang','en') };
    status.style.display='block'; status.style.color='#5b6b7b'; status.textContent=L('sending','Sending…');
    fetch('https://creatorscripts.app.n8n.cloud/webhook/event-tips-submit',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
      .then(function(r){ if(!r.ok) throw 0; status.style.color='#2e7d32'; status.textContent=L('thanks','🙌 Thanks! Your tip is in the review queue and will appear once approved.'); f.reset(); })
      .catch(function(){ status.style.color='#c62828'; status.textContent=L('err',"Hmm, that didn't go through. Please try again in a moment."); });
    return false;
  };
  (function loadTips(){
    if(!slug) return;
    fetch('https://creatorscripts.app.n8n.cloud/webhook/event-tips-read?eventId='+encodeURIComponent(slug))
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if(!data || !data.tips || !data.tips.length) return;
        var list=document.getElementById('tl-tips-list'); list.innerHTML='';
        data.tips.forEach(function(t){
          var d=document.createElement('div'); d.className='tl-tip';
          var who=document.createElement('div'); who.className='tl-who'; who.textContent=(t.name||L('anon','Anonymous athlete'))+' ';
          var cat=document.createElement('span'); cat.className='tl-cat'; cat.textContent=t.category||L('tip','Tip'); who.appendChild(cat);
          var p=document.createElement('p'); p.textContent=t.tip;
          d.appendChild(who); d.appendChild(p); list.appendChild(d);
        });
      }).catch(function(){});
  })();
})();

  } catch(e) { console.error(e); }
})();
})();
